export default __webpack_public_path__ + "static/spacer-6020895f3bbaf87c2b937a9f084aa9c9.jpg";